import { CommonModule, DatePipe } from "@angular/common";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  EMPTY,
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  map,
  of,
  switchMap,
  take,
} from "rxjs";
import { GetAllBuyersResponseDto } from "../../../core/models/orders/getAllBuyersResponseDto";
import { FileUploadDto } from "../../../core/models/shared/fileUploadDto";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { AddTaskRequestDto } from "../../../core/models/task-management/addTaskRequestDto";
import { DocumentUploadDto } from "../../../core/models/task-management/documentUploadDto";
import { ProjectWorkflowDetail } from "../../../core/models/task-management/getProjectWorkFlowDetailDto";
import { ProjectWorkFlowLinesList } from "../../../core/models/task-management/getProjectWorkFlowLinesList";
import { ProjectWorkflowTags } from "../../../core/models/task-management/getTagsByProjectWorkflowList";
import { getTaskDetailResponse } from "../../../core/models/task-management/getTaskDetailResponse";
import { SalesOrderLookupDto } from "../../../core/models/task-management/salesOrderLookupDto";
import { TasksLinkFiles } from "../../../core/models/task-management/tasksLinkFiles";
import { TaskTypeModel } from "../../../core/models/task-management/taskTypeModel";
import { UpdateTaskRequestDto } from "../../../core/models/task-management/updateTaskDto";
import { CustomerAccountService } from "../../../core/services/customer-account.service";
import { LoaderService } from "../../../core/services/loader.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import {
  getBase64,
  SharedService,
} from "../../../core/services/shared.service";
import { TaskManagementService } from "../../../core/services/task-management.service";
import { EnumSalesTaskStatus } from "../../../shared/enums/salesTaskStatus";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import {
  getColorForName,
  getTextColorForName,
  replaceString,
} from "../../../shared/globalfunction";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { Select, SelectChangeEvent, SelectModule } from "primeng/select";
import { EditorModule } from "primeng/editor";
import { DatePickerModule } from "primeng/datepicker";
import { MultiSelectModule } from "primeng/multiselect";
import { TableModule } from "primeng/table";
import { Popover, PopoverModule } from "primeng/popover";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { ConfirmChangeComponent } from "../../../shared/components/confirm-change/confirm-change.component";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { ColorPickerChangeEvent, ColorPickerModule } from "primeng/colorpicker";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";
import { SkeletonModule } from "primeng/skeleton";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { createCommentDto } from "../../../core/models/task-management/createCommentDto";
import { CommentListDto } from "../../../core/models/task-management/getCommentList";
import { AvatarModule } from "primeng/avatar";
import { GetTaskLogDto } from "../../../core/models/task-management/getTaskLogDto";
import { MsalApiService } from "../../../core/services/msal-api.service";
import { SelectButtonModule } from "primeng/selectbutton";
import { TooltipModule } from "primeng/tooltip";
import { StatusTaskList } from "../../../core/models/task-management/statusTaskDto";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { TaskTypeEnum } from "../../../shared/enums/taskTypeEnum";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { GetTaskProjectOrderLinesDetailsDto } from "../../../core/models/task-management/getTaskProjectOrderLinesDetailsDto";

@UntilDestroy()
@Component({
  selector: "jni-task-header-edit",
  templateUrl: "./task-header-edit.component.html",
  styleUrls: ["./task-header-edit.component.scss"],
  providers: [DatePipe],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SelectModule,
    EditorModule,
    DatePickerModule,
    MultiSelectModule,
    TableModule,
    PopoverModule,
    DialogModule,
    ConfirmDialogComponent,
    FormsModule,
    ConfirmChangeComponent,
    SpinnerComponent,
    ColorPickerModule,
    ButtonModule,
    InputTextModule,
    ToggleSwitchModule,
    SkeletonModule,
    AvatarModule,
    SelectButtonModule,
    TooltipModule,
  ],
})
export class TaskHeaderEditComponent implements OnInit, OnChanges {
  @ViewChild("projectSelect") projectSelect!: Select;
  @Input() showTaskHeader!: boolean;
  @Input() displayModal = false;
  @Output() closeAddTask = new EventEmitter<{
    added: boolean;
    actionType: "Add" | "Edit";
    hasFormChanged: boolean;
  }>();
  @Input() taskIdSelected = 0;
  @Input() displayAddContact = false;
  @Input() actionType: "Add" | "Edit" = "Add";
  @Output() showSmallLoaderEvent = new EventEmitter<boolean>();
  @Output() showWorkflowSummary = new EventEmitter<{
    salesOrderId: string;
    workflowId: number;
  }>();
  @Output() showOrderSummary = new EventEmitter<string>();

  form!: FormGroup;
  tagForm!: FormGroup;
  projectLists: ProjectWorkflowDetail[] = [];
  tagsList: ProjectWorkflowTags[] = [];
  selectedTagsList: ProjectWorkflowTags[] = [];
  taskDetail = {} as getTaskDetailResponse;
  projectLinesList: ProjectWorkFlowLinesList[] = [];
  projectLinesListAll: ProjectWorkFlowLinesList[] = [];
  getTaskProjectOrderLinesDetailsDto!: GetTaskProjectOrderLinesDetailsDto;
  selectedProjectLine: ProjectWorkFlowLinesList | null = null;
  ownerList: { label: string; value: string }[] = [];
  ownerListDefault: { label: string; value: string }[] = [];
  formType = "";
  lineRecId: number | null = 0;
  addedTags: ProjectWorkflowTags[] = [];
  removedTags: ProjectWorkflowTags[] = [];
  selectedTags: ProjectWorkflowTags[] = [];
  selectedProject: ProjectWorkflowDetail | null = null;
  showSmallLoader = false;
  showCommentsLoader = true;
  displayCreateTagModal = false;
  clearButton = false;
  minDate!: Date;
  isUploadingAttachment = false;
  taskTypes: TaskTypeModel[] = [
    {
      id: 1,
      title: "Sales Task",
    },
    {
      id: 2,
      title: "Production Task",
    },
  ];

  priorityLevel = [
    {
      id: 1,
      title: "Urgent",
      production: true,
      color: "#ff4d4d",
    },
    {
      id: 2,
      title: "Order",
      production: false,
      color: "#ffc966",
    },
    {
      id: 3,
      title: "Source",
      production: false,
      color: "#6666ff",
    },
    {
      id: 4,
      title: "Standard",
      production: true,
      color: "#fff",
    },
  ];

  formErrors: Record<string, string> = {
    title: "",
    titleWordLimit: "",
    project: "",
    client: "",
    linkedOrder: "",
    jobName: "",
    ihd: "",
    dueDate: "",
    assignedTo: "",
    supplier: "",
    purchaseOrderNumber: "",
    esd: "",
  };
  color1 = "";

  removedDocument: DocumentUploadDto[] = [];
  documentAttachment: DocumentUploadDto[] = [];
  addDocument: DocumentUploadDto[] = [];
  validationMessages: Record<string, Record<string, string>> = {
    title: {
      required: "Title is required.",
    },
    titleWordLimit: {
      maxlength: "Title must be less than 100 characters.",
    },
    project: {
      required: "Project is required.",
    },
    client: {
      required: "Clinet is required.",
    },
    linkedOrder: {
      required: "Linked Order is required.",
    },
    jobName: {
      required: "Job Name is required.",
    },
    ihd: {
      required: "In-Hand date is required.",
    },
    dueDate: {
      required: "Due date is required.",
    },
    supplier: {
      required: "Supplier is required.",
    },
    nickName: {
      required: "Nickname is required.",
    },
    purchaseOrderNumber: {
      required: "Purchase Order Number is required.",
    },
    // esd: {
    //   required: "Estimate Shipdate is required.",
    // },
  };
  priorityLevelFiltered: {
    id: number;
    title: string;
    production: boolean;
    color: string;
  }[] = [];
  selectedTag: ProjectWorkflowTags[] = [];
  fileObject: FileUploadDto[] = [];
  fileName!: string;
  deleteTagMessage = "Are you sure you want to proceed?";
  deleteTagVisible = false;
  deleteTagId: number | null = 0;
  ihdEnable = false;
  ihdColor = "#fafafa";
  ihdColorCodes = {
    enable: "#ffff",
    disable: "#fafafa",
  };
  mandotory = false;
  adminRole = UserRole.Admin;
  selectedBuyer = "";
  buyerLists: GetAllBuyersResponseDto[] = [];
  buyerVendor$ = new Subject<string>();
  buyerSearch$ = new Subject<string>();
  showAddBuyer = false;
  clientId = "";
  buyerLoading = false;
  buyerTotalRecords = 10000; // Large number for virtual scroll
  buyerCurrentSearchTerm = "";
  changeBuyerVisible = false;
  changeAlertVisible = false;
  changeAlertMessage =
    "The Buyer Name associated with the Project is {0}, do you want to update?";
  showAddTaskFileLinkModal = false;
  taskFileLinkModalHeader = "";
  taskLinkName = "";
  taskFileLinkMode = "";
  taskFileLink = "";
  taskFileLinkId = 0;
  taskFileLinkList: TasksLinkFiles[] = [];
  showProjectChangeConfirmationModal = false;
  showProjectChangeConfirmationModalHeading = "";
  selectedChangedProject!: number;
  previousProject!: number;
  isDueDateMandatory = true;
  savedTitle: string | null = null;
  showSalesTaskProjectFieldsOverrideModal = false;
  @Output() showAddNewProjectModal = new EventEmitter();
  @Output() showContact = new EventEmitter<string>();
  @Input() buyer = "";
  @Input() projectHeaderId!: number;
  @Input() lockProject = false;
  @Input() reloadProjects = false;
  showOwner = false;

  // Sales Task Client Lookup Properties
  clientSearch$ = new Subject<string>();
  clientLists: ClientSearchList[] = [];
  selectedClientName = "";
  selectedCustomerAccountD365 = "";

  // Sales Task Order Lookup Properties
  orderSearch$ = new Subject<string>();
  orderLists: SalesOrderLookupDto[] = [];
  selectedOrderNumber = "";

  // Project Lazy Loading Properties
  projectSearch$ = new Subject<string>();
  projectLoading = false;
  projectTotalRecords = 0;
  projectCurrentSearchTerm = "";
  projectFilterValue = "";
  projectHasMore = true;
  taskStatusList: { name: string; value: number }[] = [];
  selectedTaskStatus = "";
  comment = "";
  commentList: CommentListDto[] = [];
  newMessage = "";
  saveMessage = "";
  taskLogs: GetTaskLogDto[] = [];
  commentUserPictures = new Map<string, string>();
  private projectDropdownJustOpened = false;
  showScrollTop = false;
  showScrollBottom = false;
  hasFormChanged = false;
  taskStatus: StatusTaskList[] = [
    {
      id: EnumSalesTaskStatus.New,
      status: "New",
    },
    {
      id: EnumSalesTaskStatus.Blocked,
      status: "Blocked",
    },
    {
      id: EnumSalesTaskStatus.InProgress,
      status: "In Progress",
    },
    {
      id: EnumSalesTaskStatus.InReview,
      status: "In Review",
    },
    {
      id: EnumSalesTaskStatus.Closed,
      status: "Closed",
    },
  ];
  taskStatusProd: StatusTaskList[] = [
    {
      id: WorkflowStatusEnum.ALL,
      status: "All",
    },
    {
      id: WorkflowStatusEnum.Cancelled,
      status: "Cancelled",
    },
    {
      id: WorkflowStatusEnum.Complete,
      status: "Complete",
    },
    {
      id: WorkflowStatusEnum.Delivered,
      status: "Delivered",
    },
    {
      id: WorkflowStatusEnum.InProduction,
      status: "In Production",
    },
    {
      id: WorkflowStatusEnum.OrderWritten,
      status: "Order Written",
    },
    {
      id: WorkflowStatusEnum.PoSent,
      status: "PO Sent",
    },
    {
      id: WorkflowStatusEnum.ProjectCreated,
      status: "Project Created",
    },
    {
      id: WorkflowStatusEnum.ProofApproved,
      status: "Proof Approved",
    },
    {
      id: WorkflowStatusEnum.ProofSent,
      status: "Proof Sent",
    },
    {
      id: WorkflowStatusEnum.RevisionRequested,
      status: "Revision Requested",
    },
    {
      id: WorkflowStatusEnum.Shipped,
      status: "Shipped",
    },
  ];

  workflowStatusList!: Record<string, number>;
  taskStatusKeyPairsSales: Record<string, number> = {
    New: EnumSalesTaskStatus.New,
    Blocked: EnumSalesTaskStatus.Blocked,
    "In Progress": EnumSalesTaskStatus.InProgress,
    "In Review": EnumSalesTaskStatus.InReview,
    Closed: EnumSalesTaskStatus.Closed,
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _taskManagementService: TaskManagementService,
    private _dataPipe: DatePipe,
    private _loaderService: LoaderService,
    private _samplepoListingService: SamplepoListingService,
    private _sharedService: SharedService,
    private _customerAccountService: CustomerAccountService,
    private _msalApiService: MsalApiService,
    private _workflowService: ProjectWorkflowService,
    private _router: Router
  ) {
    this.initializeForm();
    this.initializeTagForm();
  }

  async ngOnInit() {
    await this.defaultAssignee();
    this.initProjectSearch();
    this.initFormChangeDetection();

    // If projectHeaderId is provided (redirected from project task list), set search terms
    if (this.projectHeaderId && this.projectHeaderId !== 0) {
      this.projectCurrentSearchTerm = this.projectHeaderId.toString();
      this.projectFilterValue = this.projectHeaderId.toString();
    }

    await this.getAllProjectsForUsers();
    this.initClientSearch();
    this.initOrderSearch();
    this.initBuyerSearch();
    await this.getAllTags();
    await this.getWorkflowStatusList();
    if (this.taskIdSelected && this.taskIdSelected !== 0) {
      await this.getTaskDetail();
    }
    if (this.taskIdSelected === undefined || this.taskIdSelected === 0) {
      this.minDate = new Date();
      this.form.patchValue({
        parentTask: {
          taskType: 1,
        },
      });

      // As per the ticket #13952
      this.taskStatusList = this.stateKeys(1); // For Sales Task, default to Sales Task status list
      this.form.patchValue({
        subTask: {
          status: 13,
        },
      });
      this.form.get("subTask.status")?.disable();
    }
    await this.refreshBuyerGridList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ("buyer" in changes) {
      const next = changes["buyer"].currentValue as string | null | undefined;
      if (next != null && next.trim() !== "") {
        this.selectedBuyer = next;
        this.form.patchValue({
          subTask: {
            buyerName: next,
            isBuyerChange:
              this.selectedProject?.buyerName &&
              this.selectedProject.buyerName !== next,
          },
        });
      } else {
        this.form.patchValue({
          subTask: {
            buyerName: "",
            isBuyerChange: false,
          },
        });
      }
    }
    if ("reloadProjects" in changes) {
      const reload = changes["reloadProjects"].currentValue as
        | boolean
        | null
        | undefined;
      if (reload) {
        this.getAllProjectsForUsers();
      }
    }
  }

  onColorChange(event: ColorPickerChangeEvent) {
    this.color1 = event.value as string;
  }

  private initializeForm() {
    this.form = this._formBuilder.group({
      parentTask: this._formBuilder.group({
        title: ["", [Validators.required, Validators.maxLength(256)]],
        taskType: ["", Validators.required],
        description: [""],
        notification: [false],
        isDateLess: [false],
      }),
      subTask: this._formBuilder.group({
        project: [""],
        client: [{ value: "", disabled: true }],
        linkedOrder: [{ value: "", disabled: true }],
        customerIdD365: [""], // For Sales Task client lookup
        customerNameWithNoProject: [""],
        jobName: [{ value: "", disabled: true }],
        ihd: [{ value: "", disabled: true }],
        purchaseOrderNumber: [
          { value: "", disabled: true },
          Validators.required,
        ],
        supplier: [{ value: "", disabled: true }, Validators.required],
        esd: [{ value: "", disabled: true }],
        dueDate: ["", Validators.required],
        nickName: [""],
        priority: [4],
        assignedTo: [""],
        tag: [[]],
        remindMe: [""],
        attachment: [""],
        buyerName: [""],
        isBuyerChange: [false],
        status: [
          {
            value: 0,
            disabled:
              this.taskIdSelected &&
              this.taskIdSelected !== 0 &&
              this.actionType === "Add",
          },
        ],
      }),
    });

    this.form
      .get("parentTask.taskType")
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe(taskType => {
        const type = this.taskTypes.find(it => it.id == taskType);
        if (type) {
          //this.ownerList = [];
          this.formType = type.title;
          if (type.id === 2) {
            this.form.get("subTask")?.get("esd")?.enable();
            this.priorityLevelFiltered = this.priorityLevel.filter(
              item => item.production === true
            );
            if (
              this.taskIdSelected === 0 &&
              this.selectedProject?.projectWorkflowId
            ) {
              this.getProjectWorkflowLinesList(
                this.selectedProject.projectWorkflowId
              );
            }
          } else {
            this.priorityLevelFiltered = this.priorityLevel;
          }

          // Reset client, linkedOrder, jobName when task type changes (only for new tasks)
          if (!this.taskIdSelected && !this.projectHeaderId) {
            this.resetClientOrderJobName();
            this.patchEmptyForm();
          }

          this.setDynamicValidation(this.formType);
          //this.patchEmptyForm();
        }
      });
  }

  private initializeTagForm() {
    this.tagForm = this._formBuilder.group({
      tagTitle: ["", Validators.required],
      tagColor: ["", Validators.required],
    });
  }

  /**
   * Initialize form change detection
   * Subscribes to form value changes to track if user has modified the form
   */
  private initFormChangeDetection() {
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.hasFormChanged = true;
    });
  }

  /**
   * Reset form change detection flag
   * Call this after initial form patching or when form is reset
   */
  resetFormChangeDetection() {
    this.hasFormChanged = false;
  }

  patchEmptyForm() {
    this.form.patchValue({
      subTask: {
        ihd: "",
        purchaseOrderNumber: "",
        supplier: "",
        esd: "",
        nickName: "",
        priority: 4,
      },
    });
  }

  patchFormForEditTask(taskDetail: getTaskDetailResponse) {
    const taskPatch = this.taskTypes.find(
      (item: { id: number; title: string }) => item.id == taskDetail.taskType
    );
    if (!taskDetail?.dueDate) {
      this.clearDueDateValidationAndValue();
    }
    if (taskDetail?.dueDate && new Date(taskDetail?.dueDate) < this.minDate) {
      const dueDate = new Date(taskDetail.dueDate);
      dueDate.setDate(dueDate.getDate() - 1);
      this.minDate = dueDate;
    }

    this.form.patchValue({
      parentTask: {
        title: taskDetail.title,
        taskType: taskDetail.taskType,
        description: taskDetail.description,
        notification: taskDetail.isNotificationEnabled,
        isDateLess: taskDetail.isDateLess,
      },
      subTask: {
        project: taskDetail.projectWorkflowId,
        assignedTo: taskDetail.assignedTo,
        priority: taskDetail.priorityType,
        remindMe: taskDetail.remindMe
          ? new Date(taskDetail.remindMe + "Z")
          : null,
        tag: taskDetail.tags,
        dueDate: taskDetail.dueDate ? new Date(taskDetail.dueDate) : "",
        taskType: taskPatch?.title,
        client: taskDetail.projectWorkflowId
          ? (taskDetail.clientName ?? taskDetail.client)
          : taskDetail.customerNameWithNoProject,
        linkedOrder: taskDetail.salesOrderId,
        nickName: taskDetail.nickName,
        jobName: taskDetail.jobName,
        ihd: taskDetail.orderInHandDate
          ? new Date(taskDetail.orderInHandDate)
          : "",
        buyerName: taskDetail.buyerName,
        customerIdD365: taskDetail.client, // For Sales Task lookup
        status: taskDetail.status,
        customerNameWithNoProject: taskDetail.customerNameWithNoProject,
      },
    });

    this.selectedClientName = taskDetail.projectWorkflowId
      ? (taskDetail.clientName ?? "")
      : (taskDetail.customerNameWithNoProject ?? "");

    if (taskDetail.client) {
      this.loadBuyersLazy({ first: 0, rows: 50 }, true, taskDetail.buyerName);
    }

    this.savedTitle = taskDetail.title;

    // Apply dynamic validation after patching to ensure proper field states
    const taskType =
      taskDetail.taskType === 2 ? "Production Task" : "Sales Task";
    this.setDynamicValidation(taskType);

    // Reset form change detection after patching existing task data
    this.resetFormChangeDetection();

    if (taskDetail.client) {
      this.clientId = taskDetail.client;
      this.showAddBuyer = true;
    }
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        const messages = this.validationMessages[key];

        const isRequired = abstractControl?.hasValidator(Validators.required);
        const isEmpty =
          abstractControl?.value === "" || abstractControl?.value == null;

        if (
          abstractControl &&
          !abstractControl.valid &&
          abstractControl.enabled
        ) {
          if (abstractControl.errors && messages) {
            for (const errorKey in abstractControl.errors) {
              if (errorKey && messages[errorKey]) {
                this.formErrors[key] += messages[errorKey] + " ";
              }
            }
          }
        } else if (
          abstractControl &&
          !abstractControl.enabled &&
          isRequired &&
          isEmpty
        ) {
          this.formErrors[key] += messages["required"] + " ";
        }
      }
    });
  }

  setDynamicValidation(taskType: string) {
    const subTask = this.form.get("subTask");
    if (subTask) {
      subTask.get("purchaseOrderNumber")?.clearValidators();
      subTask.get("supplier")?.clearValidators();
      subTask.get("esd")?.clearValidators();
      subTask.get("nickName")?.clearValidators();
      subTask.get("project")?.clearValidators();
      subTask.get("client")?.clearValidators();
      subTask.get("project")?.clearValidators();
      subTask.get("purchaseOrderNumber")?.clearValidators();
      subTask.get("jobName")?.clearValidators();

      if (taskType === "Sales Task") {
        if (this.taskIdSelected) {
          const parentTask = this.form.get("parentTask");
          if (parentTask) {
            parentTask.get("taskType")?.disable();
          }
          //if (this.selectedProject) {
          //  subTask.get("project")?.disable();
          //}
          subTask.get("taskType")?.disable();
          this.form.get("parent.taskType")?.disable();
        }
        // For Sales Task: nickName is not required
        // For Sales Task: Enable client and linkedOrder fields if no project is selected
        this.updateSalesTaskFieldsState();
      } else if (taskType === "Production Task") {
        subTask.get("purchaseOrderNumber")?.setValidators(Validators.required);
        subTask.get("supplier")?.setValidators(Validators.required);
        //subTask.get("esd")?.setValidators(Validators.required);
        subTask.get("nickName")?.setValidators(Validators.required);
        subTask.get("project")?.setValidators(Validators.required);
        subTask.get("ihd")?.setValidators(Validators.required);
        subTask.get("client")?.setValidators(Validators.required);
        subTask.get("purchaseOrderNumber")?.setValidators(Validators.required);
        subTask.get("jobName")?.setValidators(Validators.required);
        if (this.taskIdSelected) {
          const parentTask = this.form.get("parentTask");
          subTask.get("project")?.disable();
          subTask.get("taskType")?.disable();
          //subTask.get("nickName")?.disable(); // as in production task nick name can be editable as input field
          if (parentTask) {
            parentTask.get("taskType")?.disable();
          }
        }
        // For Production Task: Keep client and linkedOrder disabled (controlled by project selection)
        subTask.get("client")?.disable();
        subTask.get("linkedOrder")?.disable();
        subTask.get("jobName")?.disable(); // jobName is disabled for Production Task
      }
      subTask.get("project")?.updateValueAndValidity();
      subTask.get("client")?.updateValueAndValidity();
      subTask.get("jobName")?.updateValueAndValidity();
      subTask.get("ihd")?.updateValueAndValidity();
      subTask.get("purchaseOrderNumber")?.updateValueAndValidity();
      subTask.get("supplier")?.updateValueAndValidity();
      subTask.get("esd")?.updateValueAndValidity();
      subTask.get("nickName")?.updateValueAndValidity();
      subTask.get("linkedOrder")?.updateValueAndValidity();
    }
  }

  /**
   * Update Sales Task fields state based on project selection
   * When project is selected: client, linkedOrder, and jobName are disabled and populated from project
   * When no project: client, linkedOrder, and jobName are enabled for manual entry
   */
  updateSalesTaskFieldsState() {
    const subTask = this.form.get("subTask");
    const projectId = subTask?.get("project")?.value;

    if (this.formType !== "Sales Task") {
      return;
    }

    if (projectId) {
      // Project selected: disable client, linkedOrder, and jobName (values come from project)
      subTask?.get("client")?.disable();
      subTask?.get("linkedOrder")?.disable();
      subTask?.get("jobName")?.disable();
    } else {
      // No project selected: enable client, linkedOrder, and jobName for manual entry
      subTask?.get("client")?.enable();
      subTask?.get("linkedOrder")?.enable();
      subTask?.get("jobName")?.enable();
      // Only clear if not editing (new task) - when editing, keep existing values
      if (!this.taskIdSelected) {
        this.clearSalesTaskClientAndOrder();
      }
    }
    subTask?.get("client")?.updateValueAndValidity();
    subTask?.get("linkedOrder")?.updateValueAndValidity();
    subTask?.get("jobName")?.updateValueAndValidity();
  }

  /**
   * Reset client, linkedOrder, jobName, and project values when task type changes
   */
  resetClientOrderJobName() {
    this.selectedClientName = "";
    this.selectedCustomerAccountD365 = "";
    this.selectedOrderNumber = "";
    this.clientId = "";
    this.clientLists = [];
    this.orderLists = [];
    this.selectedBuyer = "";
    this.buyerLists = [];
    this.showAddBuyer = false;
    this.selectedProject = null;
    this.selectedProjectLine = null;
    this.projectLinesList = [];
    this.clearButton = false;
    this.ihdEnable = false;
    this.ihdColor = this.ihdColorCodes.disable;

    this.form.patchValue({
      subTask: {
        project: "",
        client: "",
        linkedOrder: "",
        jobName: "",
        ihd: "",
        customerIdD365: "",
        buyerName: "",
        isBuyerChange: false,
      },
    });

    // Disable IHD when no project is selected (for new tasks)

    // Only disable 'ihd' if the task type is not 'Sales Task'
    if (this.formType !== "Sales Task") {
      this.form.get("subTask")?.get("ihd")?.disable();
    }
  }

  onProjectClear() {
    this.form.patchValue({
      subTask: {
        project: "",
        client: "",
        jobName: "",
        ihd: "",
        linkedOrder: "",
        buyerName: "",
        isbuyerChange: false,
        customerIdD365: "",
        supplier: "",
        nickName: "",
      },
    });
    this.projectLinesList = [];
    this.selectedBuyer = "";
    this.clientId = "";
    this.selectedClientName = "";
    this.selectedProject = {} as ProjectWorkflowDetail;
    this.selectedProjectLine = {} as ProjectWorkFlowLinesList;
    this.clearButton = false;
    this.showAddBuyer = false;
    this.ownerList = this.ownerListDefault;

    // For Sales Task: keep IHD enabled and enable client/linkedOrder fields for lookup
    if (this.formType === "Sales Task") {
      this.ihdEnable = true;
      this.ihdColor = this.ihdColorCodes.enable;
      this.form.get("subTask")?.get("ihd")?.enable();
      this.updateSalesTaskFieldsState();
    } else {
      // For Production Task: disable IHD when no project
      this.ihdEnable = false;
      this.ihdColor = this.ihdColorCodes.disable;
      this.form.get("subTask")?.get("ihd")?.disable();
    }

    this.showSmallLoader = false;
  }

  initProjectSearch() {
    this.projectSearch$
      .pipe(debounceTime(300), distinctUntilChanged(), untilDestroyed(this))
      .subscribe((searchTerm: string) => {
        this.projectCurrentSearchTerm = searchTerm;
        this.projectLists = []; // Reset on new search
        this.projectHasMore = true; // Reset hasMore flag
        this.loadProjectsLazy({ first: 0, rows: 10 });
      });
  }

  getAllProjectsForUsers(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.showSmallLoader = true;
      this.projectLoading = true;
      // Use projectCurrentSearchTerm if already set (e.g., when projectHeaderId is provided)
      const searchText = this.projectCurrentSearchTerm || "";
      this._taskManagementService
        .getProjectDetailsPaginated({
          searchText: searchText,
          skip: 0,
          take: 10,
        })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.projectLists = res.data.map(project => ({
              ...project,
              projectLabel: `${project.projectWorkflowPaddedId} - ${project.clientName} - ${project.jobName}`,
            }));
            this.projectTotalRecords = res.totalRecords ?? 0;
            this.projectHasMore =
              this.projectLists.length < this.projectTotalRecords;
            this.projectLoading = false;
            this.showSmallLoader = false;
            if (this.projectHeaderId !== null && this.projectHeaderId !== 0) {
              this.ProjectChangeEvent(this.projectHeaderId);
            }
            resolve();
          },
          error: res => {
            this._toastr.error("Error", "Error Fetching Projects");
            this.projectLoading = false;
            this.showSmallLoader = false;
            reject(res);
          },
        });
    });
  }

  loadProjectsLazy(event: { first: number; rows: number }) {
    if (this.projectLoading || !this.projectHasMore) return;

    this.projectLoading = true;
    const skip = event.first ?? 0;
    const take = event.rows ?? 50;

    const request = {
      searchText: this.projectCurrentSearchTerm,
      skip: skip,
      take: take,
    };

    this._taskManagementService
      .getProjectDetailsPaginated(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const mappedData = res.data.map(project => ({
            ...project,
            projectLabel: `${project.projectWorkflowPaddedId} - ${project.clientName} - ${project.jobName}`,
          }));

          if (skip === 0) {
            // First load or new search - replace the list
            this.projectLists = mappedData;
          } else {
            // Append to existing list
            this.projectLists = [...this.projectLists, ...mappedData];
          }
          this.projectLoading = false;
          this.projectTotalRecords = res.totalRecords ?? 0;

          // Check if there's more data to load
          // Also mark as no more data if the response returned fewer items than requested
          const hasMoreByCount =
            this.projectLists.length < this.projectTotalRecords;
          const returnedLessThanRequested = mappedData.length < take;
          this.projectHasMore = hasMoreByCount && !returnedLessThanRequested;
        },
        error: () => {
          this.projectLoading = false;
        },
      });
  }

  onProjectFilter(event: { filter: string }) {
    const filterValue = event.filter ?? "";

    // If projectHeaderId is set and filter is being cleared, don't trigger a new search
    // The project should only be removed via clear button or selecting another project
    if (
      this.projectHeaderId &&
      this.projectHeaderId !== 0 &&
      filterValue === ""
    ) {
      // Keep the current filter value to maintain the selected project in the list
      return;
    }

    this.projectFilterValue = filterValue;
    this.projectSearch$.next(this.projectFilterValue);
  }

  onProjectLazyLoad(event: { first: number; last: number }) {
    // Don't load if dropdown just opened (prevents auto-trigger)
    if (this.projectDropdownJustOpened) {
      return;
    }

    // Don't load if already loading or no more data available
    if (this.projectLoading || !this.projectHasMore) {
      return;
    }

    // Trigger load when user has scrolled to within 5 items of the end
    const threshold = 5;
    const shouldLoadMore = event.last >= this.projectLists.length - threshold;

    if (shouldLoadMore) {
      this.loadProjectsLazy({ first: this.projectLists.length, rows: 50 });
    }
  }

  onProjectDropdownShow() {
    // Set flag to prevent auto-trigger, clear it after a short delay
    this.projectDropdownJustOpened = true;
    setTimeout(() => {
      this.projectDropdownJustOpened = false;
    }, 300);

    // Restore filter value when dropdown opens
    if (this.projectSelect && this.projectFilterValue) {
      setTimeout(() => {
        this.projectSelect.filterValue = this.projectFilterValue;
        this.projectSelect.filterOptions?.filter?.();
      });
    }
  }

  showCreateTagDisplay() {
    this.displayCreateTagModal = true;
  }

  addTag() {
    if (this.tagForm.valid) {
      this.form.patchValue({
        subTask: {
          tag: [...this.getTagsValue(), this.tagForm.getRawValue()],
        },
      });
      this.tagsList.push(this.tagForm.getRawValue());
      this.tagForm.reset();
      this.displayCreateTagModal = false;
    }
  }

  getTagsValue(): [] {
    return this.form.get("subTask.tag")?.value || [];
  }

  closeModal(added: boolean) {
    this.closeAddTask.emit({
      added: added,
      actionType: this.actionType,
      hasFormChanged: this.hasFormChanged,
    });
  }

  onDialogHide() {
    this.closeAddTask.emit({
      added: false,
      actionType: this.actionType,
      hasFormChanged: this.hasFormChanged,
    });
  }

  onNickNameChange(event: SelectChangeEvent) {
    const itemObject = this.projectLinesList.find(
      item => item.nickName === event.value
    );

    const formattedDate = this.selectedProject?.orderInHandDate
      ? new Date(this.selectedProject.orderInHandDate)
      : null;
    this.selectedProjectLine = itemObject ?? null;
    this.form.patchValue({
      subTask: {
        purchaseOrderNumber: itemObject?.poNumber ?? "",
        supplier: itemObject?.supplier ?? "",
        esd: itemObject?.esd ? new Date(itemObject.esd) : "", // this._dataPipe.transform(itemObject?.esd, "MM-dd-yyyy") ?? "",
        ihd: formattedDate,
      },
    });

    // AS per the ticket #13967 for prod tasks enable esd field.
    this.form.get("subTask")?.get("esd")?.enable();
  }

  getProjectWorkflowLinesList(projectWorkFlowId: number) {
    this._taskManagementService
      .getProjectWorkflowLinesList(projectWorkFlowId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.projectLinesList = res.data.filter(x => x.nickName !== "");
          }
        },
      });
  }

  getOwnersByProject(client: string) {
    if (client) {
      this._samplepoListingService
        .getBCForSalesOrder(client)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.ownerList = [];
            if (res.data != null && res.data.length > 0) {
              res.data.forEach((item: GetBCForSalesOrderDto) => {
                const bcEntry = {
                  label: item.projectName,
                  value: item.projectName,
                };
                this.ownerList?.push(bcEntry);
                // Set default assignee for new tasks if this is the current logged-in user
                if (
                  item.isCurrentUser &&
                  (this.taskIdSelected === undefined ||
                    this.taskIdSelected === 0)
                ) {
                  this.form.patchValue({
                    subTask: {
                      assignedTo: item.projectName,
                    },
                  });
                }
                this.getBacForSalesOrder(item.personnelNumber);
              });
              //this.ownerList?.push(bcEntry);
              //this.getBacForSalesOrder(res.data[0].personnelNumber);
            }
          },
        });
    }
  }

  getBacForSalesOrder(personnelNumber: string) {
    this.showOwner = false;
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null && res.data.length > 0) {
            res?.data.map(item => {
              if (item.name != "") {
                const newEntry = { label: item.name, value: item.name };
                this.ownerList?.push(newEntry);
                // Set default assignee for new tasks if this is the current logged-in user
                if (
                  item.isCurrentUser &&
                  (this.taskIdSelected === undefined ||
                    this.taskIdSelected === 0)
                ) {
                  this.form.patchValue({
                    subTask: {
                      assignedTo: item.name,
                    },
                  });
                }
              }
            });
          }
          this.showOwner = true;
        },
      });
  }

  defaultAssignee(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._taskManagementService
        .getDefaultAssignees()
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data != null && res.data.length > 0) {
              res?.data.map(item => {
                if (item.name != "") {
                  const exists = this.ownerList?.some(
                    x => x.value === item.name
                  );
                  if (!exists) {
                    const newEntry = { label: item.name, value: item.name };
                    this.ownerList?.push(newEntry);
                    this.ownerListDefault?.push(newEntry);
                  }
                  // Set default assignee for new tasks if this is the current logged-in user
                  if (
                    item.isCurrentUser &&
                    (this.taskIdSelected === undefined ||
                      this.taskIdSelected === 0)
                  ) {
                    this.form.patchValue({
                      subTask: {
                        assignedTo: item.name,
                      },
                    });
                  }
                }
              });
            }
            resolve();
            this.showOwner = true;
          },
          error: res => {
            this._toastr.error("Error", "Error Fetching Assignees");
            reject(res);
            this.showOwner = true;
          },
        });
    });
  }

  getAllTags(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.showSmallLoader = true;
      this._taskManagementService
        .getTagsByProjectWorkflowList()
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.tagsList = [];
            if (res.data) {
              this.tagsList = res.data;
            }
            this.showSmallLoader = false;
            resolve();
          },
          error: res => {
            this._toastr.error("Error", "Error Fetching All Tags");
            this.showSmallLoader = false;
            reject(res);
          },
        });
    });
  }

  getTaskDetail(): Promise<void> {
    return new Promise((resolve, reject) => {
      const taskID: number = this.taskIdSelected;
      this.showSmallLoader = true;
      this._taskManagementService
        .getTaskDetails(taskID)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: async res => {
            if (res.data) {
              this.taskDetail = res.data;

              const isProjectInList = this.projectLists.some(
                item => item.projectWorkflowId === res.data.projectWorkflowId
              );

              if (res.data.projectWorkflowId && !isProjectInList) {
                const fallbackProject = {
                  projectWorkflowId: res.data.projectWorkflowId,
                  sortId: res.data.sortId ?? null,
                  projectWorkflowPaddedId: res.data.projectPaddedId ?? "",
                  salesOrderId: res.data.salesOrderId ?? "",
                  client: res.data.client ?? "",
                  jobName: res.data.jobName ?? "",
                  orderInHandDate: res.data.orderInHandDate ?? undefined,
                  buyerName: res.data.buyerName ?? undefined,
                  clientName: res.data.clientName ?? undefined,
                  projectLabel: `${res.data.projectPaddedId ?? ""} - ${res.data.clientName ?? ""} - ${res.data.jobName ?? ""}`,
                };

                this.projectLists.push(fallbackProject);
              }

              this.selectedProject =
                this.projectLists.find(
                  item => item.projectWorkflowId === res.data.projectWorkflowId
                ) ?? null;

              if (this.selectedProject?.projectWorkflowId) {
                this.form.get("subTask")?.get("ihd")?.enable();
                this.ihdColor = this.ihdColorCodes.enable;
                this.ihdEnable = true;
                this.getProjectWorkflowLinesList(
                  this.selectedProject?.projectWorkflowId
                );

                if (
                  this.taskDetail?.taskType === 2 &&
                  this.taskDetail.lineRecId &&
                  this.taskDetail.lineRecId > 0
                ) {
                  this.getTaskProjectOrderLinesDetails(
                    this.selectedProject?.projectWorkflowId,
                    this.taskDetail.lineRecId ?? 0
                  );
                } else if (
                  this.taskDetail?.taskType === 2 &&
                  !this.taskDetail?.lineRecId
                ) {
                  this.getTaskProjectOrderLinesDetails(
                    this.selectedProject?.projectWorkflowId,
                    this.taskDetail.taskRecId ?? 0
                  );
                }

                this.ownerList = [];
                this.selectedTags = this.taskDetail.tags;
                this.getOwnersByProject(this.selectedProject?.client);
                if (this.selectedProject.client || res.data.client) {
                  this.showAddBuyer = true;
                }
                this.selectedClientName = this.selectedProject?.client ?? "";
                this.clientId = this.selectedProject.client || res.data.client;
                this.selectedBuyer = res.data?.buyerName
                  ? res.data?.buyerName
                  : (this.selectedProject?.buyerName ?? "");
              } else {
                this.selectedTags = res.data?.tags || [];
                this.selectedBuyer = res.data?.buyerName || "";

                // For Sales Task without project: enable IHD
                if (res.data.taskType == 1) {
                  this.ihdEnable = true;
                  this.ihdColor = this.ihdColorCodes.enable;
                  this.form.get("subTask")?.get("ihd")?.enable();
                } else {
                  this.ihdEnable = false;
                  this.ihdColor = this.ihdColorCodes.disable;
                  this.form.get("subTask")?.get("ihd")?.disable();
                }
                this.form.get("subTask")?.get("ihd")?.updateValueAndValidity();
              }
              setTimeout(() => {
                this.patchFormForEditTask(this.taskDetail);
              }, 100);
              this.documentAttachment = res.data.documents;

              if (res?.data?.linkFiles && res?.data?.linkFiles?.length > 0) {
                this.taskFileLinkList = res.data.linkFiles;
                this.taskFileLinkId = res.data.linkFiles.length;
              }

              if (res.data.taskType == 2) {
                this.formType = "Production Task";
                this.form.get("subTask")?.get("esd")?.enable();
              } else {
                this.formType = "Sales Task";

                // For Sales Task editing: populate selected lookup values (with or without project)
                this.selectedClientName = res.data.client ?? "";
                this.selectedCustomerAccountD365 = res.data.client ?? "";
                this.selectedOrderNumber = res.data.salesOrderId ?? "";
              }

              this.taskStatusList = this.stateKeys(res.data.taskType);

              this.getComments();
            }
            this.showSmallLoader = false;
          },
          error: res => {
            this._toastr.error("Error", "Error Fetching Task Details");
            this.showSmallLoader = false;
            reject(res);
          },
        });
    });
  }

  deleteDocument(index: number) {
    this.removedDocument = this.documentAttachment.splice(index, 1);
  }

  patchWorkFlowLineDetailsIntoForm() {
    const linesData = this.projectLinesListAll.find(
      item => item.lineRecId === this.taskDetail.lineRecId
    );
    if (linesData) {
      this.form.patchValue({
        subTask: {
          purchaseOrderNumber: linesData.poNumber,
          supplier: linesData.supplier,
          ihd: linesData?.inHandDate ? new Date(linesData.inHandDate) : "",
          esd: linesData?.esd ? new Date(linesData.esd) : "",
        },
      });
    }
  }

  onProjectChange(project: SelectChangeEvent) {
    this.showSmallLoader = true;
    this.buyerLists = [];
    this.buyerCurrentSearchTerm = "";
    if (project.value) {
      if (this.formType === "Sales Task") {
        // For editing Sales Task: Check if project fields differ from current values
        const newProject = this.projectLists.find(
          item => item.projectWorkflowId === project.value
        );
        const formValue = this.form.getRawValue();

        // Check if any of the fields have a value (not empty)
        const clientVal = formValue.subTask.client as string;
        const buyerVal = formValue.subTask.buyerName as string;
        const orderVal = formValue.subTask.linkedOrder as string;
        const hasExistingValues =
          (clientVal && clientVal.trim() !== "") ||
          (buyerVal && buyerVal.trim() !== "") ||
          (orderVal && orderVal.trim() !== "") ||
          formValue.subTask.ihd;

        // Only check for changes if there are existing values
        if (hasExistingValues) {
          const hasChanges =
            newProject?.client !== formValue.subTask.client ||
            newProject?.jobName !== formValue.subTask.jobName ||
            newProject?.buyerName !== formValue.subTask.buyerName ||
            (newProject?.orderInHandDate &&
              new Date(newProject.orderInHandDate).getTime() !==
                (formValue.subTask.ihd
                  ? new Date(formValue.subTask.ihd).getTime()
                  : 0));

          if (hasChanges) {
            // Show confirmation modal for Sales Task field override
            this.selectedChangedProject = project.value;
            this.showSalesTaskProjectFieldsOverrideModal = true;
            this.previousProject = this.selectedProject?.projectWorkflowId ?? 0;
          } else {
            // No changes, just apply the project
            this.previousProject = project.value;
            this.ProjectChangeEvent(project.value);
          }
        } else {
          // No existing values, directly apply the project
          this.previousProject = project.value;
          this.ProjectChangeEvent(project.value);
        }
      } else {
        // For new Sales Task or Production Task, directly apply
        this.previousProject = project.value;
        this.ProjectChangeEvent(project.value);
      }
    }
  }

  ProjectChangeEvent(project: number) {
    this.showSmallLoader = true;
    this.clearButton = true;
    this.form.get("subTask")?.get("ihd")?.enable();
    this.ihdColor = this.ihdColorCodes.enable;
    this.ihdEnable = true;
    const event = project;
    this.projectLinesList = [];
    this.selectedProject =
      this.projectLists.find(item => item.projectWorkflowId === event) ?? null;
    if (this.formType === "Production Task") {
      this.getProjectWorkflowLinesList(event);
    }
    this.getOwnersByProject(this.selectedProject?.client ?? "");
    // Show +Add buyer link when client is available (for both Sales and Production tasks)
    this.showAddBuyer = !!this.selectedProject?.client;
    this.clientId = this.selectedProject?.client ?? "";
    this.selectedClientName = this.selectedProject?.client ?? "";
    this.selectedBuyer = this.selectedProject?.buyerName ?? "";
    const formattedDate = this.selectedProject?.orderInHandDate
      ? new Date(this.selectedProject.orderInHandDate)
      : null;
    const ihdValue = this.formType === "Sales Task" ? formattedDate : null;

    // For Sales Task: Update selected values for lookup fields
    //if (this.formType === "Sales Task") {
    this.selectedClientName = this.selectedProject?.clientName ?? "";
    this.selectedCustomerAccountD365 = this.selectedProject?.client ?? "";
    this.selectedOrderNumber = this.selectedProject?.salesOrderId ?? "";
    //}
    this.loadBuyersLazy({ first: 0, rows: 50 }, true);
    this.form.patchValue({
      subTask: {
        project: this.selectedProject?.projectWorkflowId,
        client:
          this.selectedProject?.clientName ??
          this.selectedProject?.client ??
          "",
        jobName: this.selectedProject?.jobName ?? "",
        ihd: ihdValue,
        linkedOrder: this.selectedProject?.salesOrderId,
        buyerName: this.selectedProject?.buyerName,
        customerIdD365: this.selectedProject?.client ?? "",
      },
    });
    this.showSmallLoader = false;
    // For Sales Task: disable client and linkedOrder when project is selected
    if (this.formType === "Sales Task") {
      this.updateSalesTaskFieldsState();
    }
  }

  getPaddedWorkflowId(workflowId: number) {
    return workflowId.toString().padStart(6, "0");
  }

  getFormattedDate(date: Date): string {
    return this._dataPipe.transform(date, "yyyy-MM-dd") ?? "";
  }

  getTaskType(event: SelectChangeEvent) {
    if (event.value === 2) {
      this.mandotory = true;
    } else {
      this.mandotory = false;
    }
    this.formErrors = {};

    if (this.taskIdSelected === undefined || this.taskIdSelected === 0) {
      this.taskStatusList = this.stateKeys(event.value);
      if (event.value === 1) {
        this.form.patchValue({
          subTask: {
            status: 13, // For Sales Task, default to "New" status
          },
        });
      }
      // else if (event.value === 2) {
      //   this.form.patchValue({
      //     subTask: {
      //       status: 1, // For Production Task, default to "Order Written" status
      //     },
      //   });
      // }

      this.form.get("subTask.status")?.disable();
    }
  }

  addTask() {
    this.logValidationErrors(this.form);
    const hasDisabledFieldErrors =
      this.formType === "Production Task" &&
      Object.values(this.formErrors).some(e => e !== "");
    if (this.form.valid && !hasDisabledFieldErrors) {
      if (
        this.selectedProject?.buyerName &&
        this.selectedProject.buyerName !== this.selectedBuyer
      ) {
        this.changeBuyerVisible = true;
      } else {
        this.addTaskPartial();
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  addTaskPartial() {
    const region = Intl.DateTimeFormat().resolvedOptions().locale;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (this.form.valid) {
      this._loaderService.setLoaderState(true);
      const formValue = this.form.getRawValue();

      // For Sales Task without project, get salesOrderId and client from form values
      const isSalesTaskNoProject =
        this.formType === "Sales Task" &&
        !this.selectedProject?.projectWorkflowId;
      const isSalesTask = this.formType === "Sales Task";
      const salesOrderId = isSalesTaskNoProject
        ? formValue.subTask.linkedOrder
        : this.selectedProject?.salesOrderId;

      const addTaskReqBody = {
        title: formValue.parentTask.title,
        assignedTo: formValue.subTask.assignedTo,
        description: formValue.parentTask.description,
        notification: formValue.parentTask.notification,
        isDateLess: formValue.parentTask.isDateLess,
        dueDate: this._dataPipe.transform(
          formValue.subTask.dueDate,
          "MM/dd/yyyy"
        ),
        priorityType: formValue.subTask.priority,
        projectWorkflowId: this.selectedProject?.projectWorkflowId,
        remindMe: this._dataPipe.transform(
          formValue.subTask.remindMe,
          "MM/dd/yyyy HH:mm:ss"
        ),
        salesOrderLineRecIdD365:
          this.formType === "Sales Task"
            ? null
            : this.selectedProjectLine?.lineRecId,
        taskTags: formValue.subTask.tag,
        taskType: formValue.parentTask.taskType,
        taskStatus:
          this.formType === "Sales Task"
            ? EnumSalesTaskStatus.New
            : this.selectedProjectLine?.lineStatus,
        addDocumentsList: this.documentAttachment,
        region: region ?? "",
        timeZone: timezone ?? "",
        ihd: this._dataPipe.transform(formValue.subTask.ihd, "MM/dd/yyyy"),
        salesOrderId: salesOrderId,
        customerIdD365: isSalesTask
          ? formValue.subTask.customerIdD365
          : undefined,
        jobNameD365: isSalesTask ? formValue.subTask.jobName : undefined,
        buyer: formValue.subTask.buyerName,
        isBuyerChange: formValue.subTask.isBuyerChange || false,
        linkFiles: this.taskFileLinkList,
        nickName: formValue.subTask.nickName,
        customerNameWithNoProject: this.selectedProject?.projectWorkflowId
          ? ""
          : this.selectedClientName, //formValue.subTask.customerNameWithNoProject,
        esd: this._dataPipe.transform(formValue.subTask.esd, "MM/dd/yyyy"),
      } as AddTaskRequestDto;

      this._taskManagementService
        .addTask(addTaskReqBody)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.status.toLowerCase() == "success") {
              this._toastr.success("Success", "Task Created Successfully!");
              this.closeModal(true);
            } else {
              this._toastr.error("Error", "Something went wrong!");
            }
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._toastr.error("Error", "Error creating task");
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  createFileUploadDto(
    base64Url: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = base64Url.split(",")[1];
    this.fileObject = [];

    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  async uploadTrackingFile(file: Event) {
    const target = file.target as HTMLInputElement;

    if (target?.files) {
      this.isUploadingAttachment = true;
      //this.showSmallLoader = true;
      //this.showSmallLoaderEvent.emit(true);
      const fileObj = target?.files[0];
      const fileSize = Math.round(fileObj.size / 1024);
      const maxFileSize = 30 * 1024; //30 MB

      if (!fileObj) {
        this.isUploadingAttachment = false;
        return;
      }

      if (fileSize > maxFileSize) {
        this._toastr.error(
          "Error",
          "File size exceeds 30MB. Please upload a smaller file."
        );
        this.isUploadingAttachment = false;
        return;
      }

      // Define allowed file types
      const allowedTypes = [
        ".ai",
        ".esp",
        ".ppt",
        ".pdf",
        ".jpeg",
        ".jpg",
        ".eps",
        ".pptx",
        ".xlsx",
        ".xls",
        ".docx",
        ".doc",
        ".bmp",
        ".png",
      ];

      const fileExtension = "." + fileObj.name.split(".").pop()?.toLowerCase();

      if (allowedTypes.includes(fileExtension)) {
        await getBase64(fileObj).then(base64Url => {
          const base64 = base64Url as string;
          this.createFileUploadDto(
            base64,
            fileObj.name,
            fileExtension,
            fileSize,
            fileObj.type
          );
          this.fileName = fileObj.name;
          this.uploadFile(this.fileObject, this.fileObject.length - 1);
        });
      } else {
        this._toastr.error(
          "Error",
          "Invalid file type. Please upload one of the following file types: AI, ESP, PPT, PDF, JPEG, EPS, PPTX, XLSX, XLS, DOCX, DOC."
        );
        this.isUploadingAttachment = false;
      }
    }
  }

  uploadFile(fileObj: FileUploadDto[], index: number) {
    this.showSmallLoader = true;
    this._taskManagementService
      .uploadProjectFiles(fileObj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status == "Success") {
            const file = {
              name: fileObj[index].fileName,
              extension: fileObj[index].fileExtension,
              fileMimeType: fileObj[index].fileMimeType,
              size: fileObj[index].fileSize,
              url: res.data,
            };
            this.documentAttachment.push(file);
            if (this.taskIdSelected) {
              this.addDocument.push(file);
            }
          }
          this.showSmallLoader = false;
          this.isUploadingAttachment = false;
        },
      });
  }

  configureTags() {
    const tags: ProjectWorkflowTags[] = this.form.get([
      "subTask",
      "tag",
    ])?.value;
    this.addedTags = tags.filter(item => !this.selectedTags.includes(item));
    this.removedTags = this.selectedTags.filter(item => !tags.includes(item));
  }

  updateTask() {
    this.logValidationErrors(this.form);
    const hasDisabledFieldErrors =
      this.formType === "Production Task" &&
      Object.values(this.formErrors).some(e => e !== "");
    if (this.form.valid && !hasDisabledFieldErrors) {
      if (
        this.selectedProject?.buyerName &&
        this.selectedProject.buyerName !== this.selectedBuyer
      ) {
        this.changeBuyerVisible = true;
      } else {
        this.updateTaskPartial();
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  updateTaskPartial() {
    if (this.form.valid) {
      this.configureTags();
      this.showSmallLoader = true;
      this.showSmallLoaderEvent.emit(true);
      const formValue = this.form.getRawValue();
      let priorityObj;
      if (typeof formValue.subTask.priority == "string") {
        priorityObj = this.priorityLevel.find(
          item => formValue.subTask.priority === item.title
        );
      } else {
        priorityObj = this.priorityLevel.find(
          item => formValue.subTask.priority === item.id
        );
      }
      const updateTaskReq = {
        title: formValue.parentTask.title,
        assignedTo: formValue.subTask.assignedTo,
        description: formValue.parentTask.description,
        notification: formValue.parentTask.notification,
        isDateLess: formValue.parentTask.isDateLess,
        dueDate: this._dataPipe.transform(
          formValue.subTask.dueDate,
          "MM/dd/yyyy"
        ),
        priorityType: priorityObj?.id,
        remindMe: this._dataPipe.transform(
          formValue.subTask.remindMe,
          "MM/dd/yyyy HH:mm:ss"
        ),
        addTaskTags:
          this.addedTags && this.addedTags.length > 0 ? this.addedTags : null,
        deleteTaskTags:
          this.removedTags && this.removedTags.length > 0
            ? this.removedTags
            : null,
        taskId: this.taskIdSelected,
        deleteDocumentsList: this.removedDocument,
        addDocumentsList: this.addDocument,
        ihd: this._dataPipe.transform(formValue.subTask.ihd, "MM/dd/yyyy"),
        saleOrderId: this.selectedProject?.salesOrderId,
        lineRecId: this.taskDetail.lineRecId,
        projectWorkflowId: this.selectedProject?.projectWorkflowId,
        buyer: formValue.subTask.buyerName,
        isBuyerChange: formValue.subTask.isBuyerChange || false,
        linkFiles: this.taskFileLinkList,
        isLinkFilesUpdated: true,
        nickName: formValue.subTask.nickName,
        customerIdD365:
          this.formType === "Sales Task"
            ? formValue.subTask.customerIdD365
            : undefined,
        jobNameD365:
          this.formType === "Sales Task"
            ? formValue.subTask.jobName
            : undefined,
        customerNameWithNoProject: this.selectedProject?.projectWorkflowId
          ? ""
          : this.selectedClientName, //formValue.subTask.customerNameWithNoProject,
        status: formValue.subTask.status,
        esd: this._dataPipe.transform(formValue.subTask.esd, "MM/dd/yyyy"),
      } as UpdateTaskRequestDto;

      this._taskManagementService
        .updateTask(updateTaskReq)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.status.toLowerCase() == "success") {
              if (this.savedTitle !== formValue.parentTask.title) {
                this.addComment(formValue.parentTask.title).subscribe();
              }
              this._toastr.success("Success", "Task Updated Successfully!");
              this.showSmallLoader = false;
              this.showSmallLoaderEvent.emit(false);
              this.closeModal(true);
            } else {
              this._toastr.error("Error", "Something went wrong!");
              this.showSmallLoaderEvent.emit(false);
              this.showSmallLoader = false;
            }
          },
          error: () => {
            this._toastr.error("Error", "Error editing task");
            this.showSmallLoader = false;
            this.showSmallLoaderEvent.emit(false);
          },
        });
    }
  }

  deletePTag(tagId: number) {
    this.deleteTagVisible = true;
    this.deleteTagId = tagId;
  }

  confirmDeletePTag(event: boolean) {
    if (event && this.deleteTagId) {
      this._taskManagementService
        .deletePTag(this.deleteTagId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.status.toLowerCase() === "success") {
              this.getAllTags();
            }
          },
        });
    }
    this.deleteTagVisible = false;
  }

  isIhdDisabled(): boolean {
    return this.form.get("subTask")?.get("ihd")?.disabled ?? false;
  }

  initBuyerSearch() {
    this.buyerSearch$
      .pipe(debounceTime(300), distinctUntilChanged(), untilDestroyed(this))
      .subscribe((searchTerm: string) => {
        this.buyerCurrentSearchTerm = searchTerm;
        this.buyerLists = []; // Reset on new search
        this.buyerHasMore = true; // Reset hasMore flag
        this.loadBuyersLazy({ first: 0, rows: 50 });
      });
  }

  searchBuyerName(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.buyerLoading = true;
      this._taskManagementService
        .getAllBuyersPaginated({ buyer: "", client: "", skip: 0, take: 50 })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            this.buyerLoading = false;
            this.buyerTotalRecords = res.totalRecords ?? 0;
            resolve();
          },
          error: (res: unknown) => {
            this._toastr.error("Error", "Unable to get Buyer List");
            this.buyerLoading = false;
            reject(res);
          },
        });
    });
  }

  getBuyer(
    event: KeyboardEvent | MouseEvent | Event,
    mydrop: Popover,
    element: HTMLElement
  ) {
    const target = event.target as HTMLInputElement;
    const searchValue = target.value ?? "";
    mydrop.show(event, element);

    // On focus/click, load initial data if list is empty
    if (event.type === "focus" || event.type === "click") {
      if (this.buyerLists.length === 0) {
        this.buyerCurrentSearchTerm = searchValue;
        this.buyerHasMore = true;
        this.loadBuyersLazy({ first: 0, rows: 50 });
      }
    } else {
      // On keyup, use debounced search
      this.buyerSearch$.next(searchValue);
    }
  }

  buyerHasMore = true;

  loadBuyersLazy(
    event?: { first: number; rows: number } | null,
    refresh = false,
    buyerName = ""
  ) {
    if ((this.buyerLoading || !this.buyerHasMore) && refresh === false) return;
    this.showSmallLoader = true;
    this.buyerLoading = true;
    const skip = event?.first ?? 0;
    const take = event?.rows ?? 50;

    const request = {
      buyer: this.buyerCurrentSearchTerm || buyerName || "",
      client: this.selectedProject?.client ?? this.clientId ?? "",
      skip: skip,
      take: take,
    };

    if (request.buyer === "" && request.client === "") {
      this.showSmallLoader = false;
      this.buyerLoading = false;
      return;
    }

    this._taskManagementService
      .getAllBuyersPaginated(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (skip === 0) {
            // First load or new search - replace the list
            this.buyerLists = res.data;
          } else {
            // Append to existing list
            this.buyerLists = [...this.buyerLists, ...res.data];
          }
          this.buyerLoading = false;
          this.buyerTotalRecords = res.totalRecords ?? 0;
          // Check if there's more data to load
          this.buyerHasMore = this.buyerLists.length < this.buyerTotalRecords;
          this.showSmallLoader = false;
        },
        error: () => {
          this.buyerLoading = false;
          this.showSmallLoader = false;
        },
      });
  }

  onBuyerTableScroll(event: Event) {
    const target = event.target as HTMLElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    // Check if scrolled to bottom (with 50px threshold)
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      if (!this.buyerLoading && this.buyerHasMore) {
        this.loadBuyersLazy({ first: this.buyerLists.length, rows: 50 });
      }
    }
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover
  ) {
    let buyerChange = false;
    if (this.selectedProject?.buyerName !== event.buyer) {
      if (this.selectedProject?.buyerName) {
        this.changeAlertMessage = replaceString(
          this.changeAlertMessage,
          this.selectedProject.buyerName
        );
        this.changeAlertVisible = true;
      }
      buyerChange = true;
    }
    this.selectedBuyer = event.buyer;
    this.form.patchValue({
      subTask: {
        buyerName: event.buyer,
        isBuyerChange: buyerChange,
      },
    });
    buyerProspetToggle.hide();
  }

  populateContactAddedInfo(buyer: string) {
    this.selectedBuyer = buyer;
    this.form.patchValue({
      subTask: {
        buyerName: buyer,
        isBuyerChange: true,
      },
    });
    this.refreshBuyerGridList();
  }

  addContactInformation() {
    this.showContact.emit(this.clientId);
  }

  confirmChangeBuyer(event: boolean) {
    if (event) {
      if (this.taskIdSelected) {
        this.updateTaskPartial();
      } else {
        this.addTaskPartial();
      }
    }
    this.changeBuyerVisible = false;
  }

  confirmAlertBuyer(event: boolean) {
    if (!event) {
      this.selectedBuyer = this.selectedProject?.buyerName ?? "";
      this.form.patchValue({
        subTask: {
          buyerName: this.selectedProject?.buyerName ?? "",
          isBuyerChange: false,
        },
      });
    }
    this.changeAlertVisible = false;
  }

  openTaskFileLinkDailog(
    mode = "",
    file: TasksLinkFiles = {} as TasksLinkFiles
  ) {
    this.taskFileLinkModalHeader = mode + " File Link";
    this.showAddTaskFileLinkModal = true;
    this.taskFileLinkMode = mode;

    if (mode === "Edit") {
      this.taskFileLink = file.fileUrl;
      this.taskLinkName = file.fileName;
      this.taskFileLinkId = file.id;
    } else {
      this.taskFileLink = "";
      this.taskLinkName = "";
      this.taskFileLinkId = this.taskFileLinkId + 1;
    }
  }

  addTaskFileLink() {
    const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;
    if (this.taskFileLink === "" || this.taskFileLink === "") {
      this._toastr.error("Error", "File Link or Name cannot be empty");
      return;
    }

    if (!urlRegex.test(this.taskFileLink.trim())) {
      this._toastr.error("Error", "Enter a valid URL");
      return;
    }

    const link: TasksLinkFiles = {
      id: this.taskFileLinkId,
      fileName: this.taskLinkName.trim(),
      fileUrl: this.taskFileLink.trim(),
      isLink: true,
      taskId: this.taskIdSelected ? this.taskIdSelected : 0,
    };

    this.taskFileLinkList.push(link);
    this.closeLinkFileLinkDailog();
  }

  editTaskFileLink() {
    const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;
    if (this.taskFileLink === "" || this.taskFileLink === "") {
      this._toastr.error("Error", "File Link or Name cannot be empty");
      return;
    }

    if (!urlRegex.test(this.taskFileLink.trim())) {
      this._toastr.error("Error", "Enter a valid URL");
      return;
    }

    const obj = this.taskFileLinkList.find(x => x.id == this.taskFileLinkId);
    if (obj) {
      obj.fileName = this.taskLinkName;
      obj.fileUrl = this.taskFileLink;
    }

    this.closeLinkFileLinkDailog();
  }

  closeLinkFileLinkDailog() {
    this.showAddTaskFileLinkModal = false;
    this.taskFileLink = "";
    this.taskLinkName = "";
  }

  deleteLink(obj: TasksLinkFiles) {
    if (obj) {
      this.taskFileLinkList = this.taskFileLinkList.filter(x => x !== obj);
    }
  }

  editLink(obj: TasksLinkFiles) {
    this.openTaskFileLinkDailog("Edit", obj);
  }

  get isSalesTaskSelected(): boolean {
    const selectedId = this.form.get("parentTask.taskType")?.value;
    const selectedTask = this.taskTypes.find(
      (item: TaskTypeModel) => item.id == selectedId
    );
    return selectedTask?.title === "Sales Task";
  }

  openAddNewProjectModal() {
    this.showAddNewProjectModal.emit();
  }

  onDateLessSwitchChangeEvent(obj: ToggleSwitchChangeEvent) {
    const flag = obj?.checked ?? false;
    if (flag === true) {
      this.clearDueDateValidationAndValue();
    } else {
      this.applyValidationsToDueDate();
    }
  }

  clearDueDateValidationAndValue() {
    this.form.patchValue({
      subTask: {
        dueDate: "",
      },
    });
    const dueDateControl = this.form.get("subTask.dueDate");
    if (dueDateControl) {
      this.isDueDateMandatory = false;
      dueDateControl.clearValidators();
      dueDateControl.markAsPristine();
      dueDateControl.markAsUntouched();
      dueDateControl.setErrors(null);
      dueDateControl.disable();
      dueDateControl.updateValueAndValidity();
    }
  }

  applyValidationsToDueDate() {
    const dueDateControl = this.form.get("subTask.dueDate");
    this.isDueDateMandatory = true;
    if (dueDateControl) {
      dueDateControl.enable();
      dueDateControl.setValidators(Validators.required);
      dueDateControl.updateValueAndValidity();
    }
  }

  projectChangeYesBtnClicked() {
    this.ProjectChangeEvent(this.selectedChangedProject);
    this.showProjectChangeConfirmationModal = false;
  }

  projectChangeNoBtnClicked() {
    this.showProjectChangeConfirmationModal = false;
  }

  /**
   * Handle confirmation for Sales Task project fields override
   * User confirms to override Client, Job Name, Buyer, IHD values with selected project
   */
  salesTaskProjectFieldsOverrideYes() {
    this.ProjectChangeEvent(this.selectedChangedProject);
    this.showSalesTaskProjectFieldsOverrideModal = false;
  }

  /**
   * Handle cancellation for Sales Task project fields override
   * User chooses to keep existing values in the sales task
   */
  salesTaskProjectFieldsOverrideNo() {
    // Revert to previous project selection
    this.form.patchValue({
      subTask: {
        project: this.previousProject || null,
      },
    });
    this.showSalesTaskProjectFieldsOverrideModal = false;
    this.showSmallLoader = false;
  }

  fileDownload(url: string | undefined) {
    if (url !== undefined) {
      this._sharedService.getFileAsBlob(url).subscribe({
        next: res => {
          const blob = new Blob([res], { type: res.type });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        },
      });
    }
  }

  // addComment(comment: string): Observable<boolean> {
  //   const commentPayload = {
  //     comment: comment,
  //     taskId: this.taskDetail.taskId,
  //   } as createCommentDto;
  //   return this._taskManagementService.addCommentinTask(commentPayload).pipe(
  //     take(1),
  //     map(res => {
  //       const ok = (res?.status ?? "").toLowerCase() === "success";
  //       return ok;
  //     }),
  //     catchError(() => {
  //       return of(false);
  //     })
  //   );
  // }

  // =====================================================
  // Sales Task Client Lookup Methods (taskType === 1)
  // =====================================================

  /**
   * Initialize client search subscription for Sales Task
   * This searches clients by name or account number
   */
  initClientSearch() {
    this.clientSearch$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchItem: string) => {
          this.clientLists = [];
          // If search is cleared, also clear the selected customer account
          if (!searchItem || searchItem.trim() === "") {
            this.selectedCustomerAccountD365 = "";
            this.form.patchValue({
              subTask: {
                customerIdD365: "",
              },
            });
          }
          if (searchItem && searchItem.trim() !== "") {
            this.showSmallLoader = true;
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              searchItem
            );
          }
          return EMPTY;
        }),
        untilDestroyed(this)
      )
      .subscribe({
        next: res => {
          if (res?.data) {
            this.clientLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  /**
   * Handle client search popover opening (keyup event)
   */
  onClientSearchOpenToggle(mydrop: Popover, event: Event, target: HTMLElement) {
    mydrop.show(event, target);
  }

  /**
   * Handle client selection from popover for Sales Task
   */
  onSalesTaskClientSelection(client: ClientSearchList, popover: Popover) {
    this.selectedClientName = client.organizationNameD365;
    this.selectedCustomerAccountD365 = client.clientAccount;
    this.clientId = client.clientAccount; // Set clientId for buyer search

    // Clear buyer when client changes and enable +Add buyer link
    this.selectedBuyer = "";
    this.buyerLists = [];
    this.showAddBuyer = true;

    this.form.patchValue({
      subTask: {
        client: client.organizationNameD365,
        customerIdD365: client.clientAccount,
        buyerName: "",
        isBuyerChange: false,
      },
    });

    // Clear order selection when client changes
    this.selectedOrderNumber = "";
    this.orderLists = [];
    this.form.patchValue({
      subTask: {
        linkedOrder: "",
      },
    });

    popover.hide();
  }

  /**
   * Handle client input change - clear value if manually edited
   */
  onClientInputChange(event: Event) {
    const inputTarget = event.target as HTMLInputElement;
    const inputValue = inputTarget.value;

    this.buyerLists = [];
    // If the input value doesn't match the selected client name, clear lookup metadata
    // but keep the typed text in the form field (allow free-text entry)
    if (inputValue !== this.selectedClientName) {
      this.selectedClientName = inputValue; // Track current typed value
      this.selectedCustomerAccountD365 = "";
      this.clientId = "";

      // Clear buyer since it was tied to the previously selected client
      this.selectedBuyer = "";
      this.showAddBuyer = false;

      this.form.patchValue({
        subTask: {
          client: inputValue, // Keep the typed text, don't clear it
          customerIdD365: "",
          buyerName: "",
          isBuyerChange: false,
        },
      });

      // Only clear order when actively typing a new client (not when clearing the field)
      if (inputValue && inputValue.trim() !== "") {
        this.selectedOrderNumber = "";
        this.orderLists = [];
        this.form.patchValue({
          subTask: {
            linkedOrder: "",
          },
        });
      }
    }
  }

  /**
   * Handle Tab key on client input to auto-select first result
   */
  onClientSearchTab(event: Event, popover: Popover) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key?.toLowerCase() === "tab") {
      if (this.clientLists.length > 0) {
        this.onSalesTaskClientSelection(this.clientLists[0], popover);
      }
    }
  }

  // =====================================================
  // Sales Task Order Lookup Methods (taskType === 1)
  // =====================================================

  /**
   * Initialize order search subscription for Sales Task
   * This searches orders by order number, filtered by selected customer if any
   */
  initOrderSearch() {
    this.orderSearch$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchItem: string) => {
          this.orderLists = [];
          if (searchItem && searchItem.trim() !== "") {
            this.showSmallLoader = true;
            // If customer is selected, filter orders by customer
            // Otherwise, search all orders by order number
            return this._taskManagementService.getSalesOrdersListByClientOrOrder(
              this.selectedCustomerAccountD365 || "",
              searchItem
            );
          }
          return EMPTY;
        }),
        untilDestroyed(this)
      )
      .subscribe({
        next: res => {
          if (res?.data) {
            this.orderLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  /**
   * Handle order search popover opening (keyup/focus/click event)
   * Triggers API search only on focus if there's already a value
   */
  onOrderSearchOpenToggle(mydrop: Popover, event: Event, target: HTMLElement) {
    const inputTarget = event.target as HTMLInputElement;
    mydrop.show(event, target);

    // Only trigger search on focus event if there's already a value
    if (
      event.type === "focus" &&
      inputTarget.value &&
      inputTarget.value.trim() !== ""
    ) {
      this.orderSearch$.next(inputTarget.value);
    }
  }

  /**
   * Handle order selection from popover for Sales Task
   */
  onSalesTaskOrderSelection(order: SalesOrderLookupDto, popover: Popover) {
    this.selectedOrderNumber = order.salesOrderIdD365;
    // Also update client info if order has customer data and client wasn't already selected
    if (order.customerAccountD365 && !this.selectedCustomerAccountD365) {
      this.selectedClientName = order.customerName;
      this.selectedCustomerAccountD365 = order.customerAccountD365;
      this.form.patchValue({
        subTask: {
          client: order.customerName,
          customerIdD365: order.customerAccountD365,
        },
      });
    }

    this.form.patchValue({
      subTask: {
        linkedOrder: order.salesOrderIdD365,
      },
    });

    popover.hide();
  }

  /**
   * Handle order input change - clear value if manually edited
   */
  onOrderInputChange(event: Event) {
    const inputTarget = event.target as HTMLInputElement;
    const inputValue = inputTarget.value;

    // If the input value doesn't match the selected order number, clear it
    if (inputValue !== this.selectedOrderNumber) {
      this.selectedOrderNumber = "";
      this.form.patchValue({
        subTask: {
          linkedOrder: "",
        },
      });
    }
  }

  /**
   * Handle Tab key on order input to auto-select first result
   */
  onOrderSearchTab(event: Event, popover: Popover) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key?.toLowerCase() === "tab") {
      if (this.orderLists.length > 0) {
        this.onSalesTaskOrderSelection(this.orderLists[0], popover);
      }
    }
  }

  /**
   * Check if Sales Task has no project selected
   * Used to determine if client and order lookups should be enabled
   */
  get isSalesTaskWithoutProject(): boolean {
    const taskType = this.form.get("parentTask.taskType")?.value;
    const projectId = this.form.get("subTask.project")?.value;
    return taskType === 1 && !projectId;
  }

  /**
   * Check if Sales Task has a project selected
   * Used to determine if client and order fields should be disabled
   */
  get isSalesTaskWithProject(): boolean {
    const taskType = this.form.get("parentTask.taskType")?.value;
    const projectId = this.form.get("subTask.project")?.value;
    return taskType === 1 && !!projectId;
  }

  /**
   * Clear client and order selections for Sales Task
   */
  clearSalesTaskClientAndOrder() {
    this.selectedClientName = "";
    this.selectedCustomerAccountD365 = "";
    this.selectedOrderNumber = "";
    this.clientLists = [];
    this.orderLists = [];
    this.form.patchValue({
      subTask: {
        client: "",
        linkedOrder: "",
        customerIdD365: "",
        jobName: "",
      },
    });
  }

  sendMessage() {
    if (!this.comment) {
      this._toastr.error("Add some comment to post!");
      return;
    }
    const mentionRegex = /@([\w.]+@[\w.]+\.\w+)|@(\w+)/g;
    const commentStr = this.comment.replace(
      mentionRegex,
      (match, email, mention) => {
        if (email) {
          return match;
        }
        const user = this.ownerList.find(x => x.label === mention);
        return user ? `@<${user.value}, ${user.label}>` : match;
      }
    );
    this.sendComment(commentStr);
    this.newMessage = "";
    this.saveMessage = "";
  }

  async sendComment(comment: string) {
    this.showSmallLoader = true;
    try {
      const ok = await firstValueFrom(this.addComment(comment));
      if (ok) this._toastr.success("Comment submitted", "Success");
      this.getTaskLog();
    } catch {
      this._toastr.error("Failed to submit comment", "Error");
    } finally {
      this.showSmallLoader = false;
    }
  }

  addComment(comment: string) {
    const commentPayload = {
      comment: comment,
      taskId: this.taskDetail.taskId,
    } as createCommentDto;
    return this._taskManagementService.addCommentinTask(commentPayload).pipe(
      take(1),
      map(res => {
        const ok = (res?.status ?? "").toLowerCase() === "success";
        if (ok) {
          this.comment = "";
          this.getComments();
        }
        return ok;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  getComments() {
    this.showCommentsLoader = true;
    this._taskManagementService
      .getCommentsByTask(
        this.taskDetail.taskId,
        this.taskDetail.projectWorkflowId
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.commentList = res.data;
          // Load profile pictures for each unique user
          this.loadCommentUserPictures();
          this.showCommentsLoader = false;
        },
        error: () => {
          this.showCommentsLoader = false;
        },
      });
  }

  loadCommentUserPictures() {
    const uniqueEmails = [
      ...new Set(this.commentList.map(c => c.createdByEmail)),
    ];
    uniqueEmails.forEach(email => {
      if (email && !this.commentUserPictures.has(email)) {
        this.getUserProfilePicture(email);
      }
    });
  }

  getUserProfilePicture(email: string) {
    this._msalApiService
      .getUserProfilePicture(email)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: blob => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64data = reader.result as string;
            this.commentUserPictures.set(email, base64data);
          };
          reader.readAsDataURL(blob);
        },
        error: () => {
          // If picture fails to load, we'll fall back to initials
          this.commentUserPictures.set(email, "");
        },
      });
  }

  getColor(name: string) {
    return getColorForName(name);
  }

  getTextColor(name: string) {
    return getTextColorForName(name);
  }

  getAcronym(word: string) {
    return word?.match(/\b(\w)/g)?.join("");
  }

  getTaskLog() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getTaskLogs(this.taskDetail.taskId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.status.toLowerCase() == "success") {
            this.taskLogs = res.data;
            this.taskLogs.forEach((element: GetTaskLogDto) => {
              element.log = element.log.replace("\n", "<br>");
            });
            // Check if scroll indicators are needed after data loads
            setTimeout(() => this.checkScrollIndicators(), 100);
          }
        },
      });
  }

  private checkScrollIndicators(element?: HTMLElement) {
    if (!element) {
      const container = document.querySelector(".task-logs-container");
      if (!container) return;
      element = container as HTMLElement;
    }

    const { scrollTop, scrollHeight, clientHeight } = element;
    const threshold = 5; // Small threshold to account for floating point precision

    this.showScrollTop = scrollTop > threshold;
    this.showScrollBottom = scrollTop < scrollHeight - clientHeight - threshold;
  }

  getRelativeTime(date: Date | string): string {
    const now = new Date();
    if (typeof date === "string" && !date) {
      return "";
    }

    let inputDate: Date;

    if (typeof date === "string" && date) {
      // Remove extra millisecond precision first
      let cleanedDateString = date;
      if (date.includes(".")) {
        const dotIndex = date.indexOf(".");
        // Remove everything after the dot (milliseconds)
        cleanedDateString = date.substring(0, dotIndex);
      }

      // Check if the string has timezone information
      const hasTimezone =
        cleanedDateString.endsWith("Z") ||
        /[+-]\d{2}:\d{2}$/.test(cleanedDateString);

      if (!hasTimezone) {
        // No timezone info: Assume it's Pacific Time and convert to local
        // Replace space with 'T' to make it ISO format
        const isoString = cleanedDateString.replace(" ", "T");

        // Parse as Pacific Time by appending Pacific timezone offset
        // We need to determine if it's PST (-08:00) or PDT (-07:00)
        const tempDate = new Date(isoString);
        const pacificOffset = this.getPacificTimezoneOffset(tempDate);

        // Append the Pacific timezone offset
        const pacificDateString = `${isoString}${pacificOffset}`;
        inputDate = new Date(pacificDateString);
      } else {
        // Has timezone: Parse as-is and JavaScript will convert to local
        inputDate = new Date(cleanedDateString);
      }

      // Check if date is valid
      if (isNaN(inputDate.getTime())) {
        console.error("Invalid date format:", date);
        return "";
      }
    } else {
      inputDate = date as Date;
    }

    const diffInMs = now.getTime() - inputDate.getTime();
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    // Get date components
    const inputDay = inputDate.getDate();
    const inputMonth = inputDate.getMonth();
    const inputYear = inputDate.getFullYear();
    const nowDay = now.getDate();
    const nowMonth = now.getMonth();
    const nowYear = now.getFullYear();

    // Days of week
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthsOfYear = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Less than 1 minute
    if (diffInSeconds < 60) {
      return "just now";
    }
    // Less than 1 hour
    else if (diffInMinutes < 60) {
      return `${diffInMinutes} ${diffInMinutes === 1 ? "minute" : "minutes"} ago`;
    }
    // Less than 24 hours (same day)
    else if (
      diffInHours < 24 &&
      inputDay === nowDay &&
      inputMonth === nowMonth &&
      inputYear === nowYear
    ) {
      return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
    }
    // Yesterday
    else if (diffInDays === 1 || (diffInDays < 2 && inputDay === nowDay - 1)) {
      return "Yesterday";
    }
    // Within last 7 days - show day name
    else if (diffInDays < 7) {
      const dayName = daysOfWeek[inputDate.getDay()];
      return dayName;
    }
    // Within current year - show "Day, Month Date"
    else if (inputYear === nowYear) {
      const dayName = daysOfWeek[inputDate.getDay()];
      const monthName = monthsOfYear[inputMonth];
      return `${dayName}, ${monthName} ${inputDay}`;
    }
    // Different year - show "Day, Month Date, Year"
    else {
      const dayName = daysOfWeek[inputDate.getDay()];
      const monthName = monthsOfYear[inputMonth];
      return `${dayName}, ${monthName} ${inputDay}, ${inputYear}`;
    }
  }

  /**
   * Determine Pacific timezone offset with DST consideration
   * Returns -07:00 for PDT (Daylight Saving Time) or -08:00 for PST (Standard Time)
   */
  private getPacificTimezoneOffset(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-11
    const day = date.getDate();

    // DST starts: Second Sunday in March at 2:00 AM
    // DST ends: First Sunday in November at 2:00 AM

    // Calculate second Sunday in March
    const marchFirst = new Date(year, 2, 1); // March 1st
    const marchFirstDay = marchFirst.getDay(); // Day of week (0=Sunday)
    const dstStart = new Date(year, 2, ((14 - marchFirstDay) % 7) + 8, 2, 0, 0);

    // Calculate first Sunday in November
    const novemberFirst = new Date(year, 10, 1); // November 1st
    const novemberFirstDay = novemberFirst.getDay();
    const dstEnd = new Date(
      year,
      10,
      ((7 - novemberFirstDay) % 7) + 1,
      2,
      0,
      0
    );

    // Check if date is within DST period
    const dateTime = new Date(
      year,
      month,
      day,
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
    const isDST = dateTime >= dstStart && dateTime < dstEnd;

    return isDST ? "-07:00" : "-08:00";
  }

  getFormattedDateForComments(date: Date | string): string {
    if (!date) return "";

    let inputDate: Date;

    if (typeof date === "string") {
      // Remove extra millisecond precision
      let cleanedDateString = date;
      if (date.includes(".")) {
        const dotIndex = date.indexOf(".");
        cleanedDateString = date.substring(0, dotIndex);
      }

      // Check if the string has timezone information
      const hasTimezone =
        cleanedDateString.endsWith("Z") ||
        /[+-]\d{2}:\d{2}$/.test(cleanedDateString);

      if (!hasTimezone) {
        // No timezone info: Assume it's Pacific Time and convert to local
        const isoString = cleanedDateString.replace(" ", "T");

        // Parse as Pacific Time by appending Pacific timezone offset
        const tempDate = new Date(isoString);
        const pacificOffset = this.getPacificTimezoneOffset(tempDate);

        // Append the Pacific timezone offset
        const pacificDateString = `${isoString}${pacificOffset}`;
        inputDate = new Date(pacificDateString);
      } else {
        // Has timezone: Parse as-is and JavaScript will convert to local
        inputDate = new Date(cleanedDateString);
      }

      // Check if date is valid
      if (isNaN(inputDate.getTime())) {
        console.error("Invalid date format:", date);
        return "";
      }
    } else {
      inputDate = date;
    }

    // Transform to local timezone with short format (includes date and time)
    return this._dataPipe.transform(inputDate, "short") ?? "";
  }

  stateKeys(taskType: number) {
    if (Number(taskType) === Number(TaskTypeEnum.Production)) {
      return this._sharedService.enumToList(this.workflowStatusList);
    } else {
      return this._sharedService.enumToList(this.taskStatusKeyPairsSales);
    }
  }

  getWorkflowStatusList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.showSmallLoaderEvent.emit(true);
      this.showSmallLoader = true;
      this._workflowService.getWorkflowStatusList().subscribe({
        next: res => {
          this.workflowStatusList = {};
          const statusEnums: Record<string, number> = {};
          if (res?.data) {
            res.data.forEach((status: { status: string; id: number }) => {
              if (status.id !== 9) {
                statusEnums[status.status] = status.id;
              }
            });
            this.workflowStatusList = statusEnums;
          }
          this.showSmallLoader = false;
          this.showSmallLoaderEvent.emit(false);
          resolve();
        },
        error: err => {
          this._toastr.error("Error", "Unable to get Workflow Status List");
          this.showSmallLoader = false;
          this.showSmallLoaderEvent.emit(false);
          reject(err);
        },
      });
    });
  }

  openWorkflowSummaryModal(salesOrderId: string, workflowId: number) {
    if (salesOrderId && workflowId) {
      this._router.navigate([
        "/",
        "project-workflow",
        "workflow-summary",
        workflowId,
        salesOrderId,
      ]);
    }
  }

  openOrderSummaryModal(salesOrderId: string) {
    if (salesOrderId) {
      this._router.navigate(["/", "orders", "order-summary", salesOrderId]);
    }
  }

  /**
   * Handles keydown events to trigger updateTask on Enter, except in <p-editor> or <textarea> fields.
   */
  onDialogKeydown(event: KeyboardEvent) {
    if (
      event.key === "Enter" &&
      event.target &&
      !(event.target as HTMLElement).closest("p-editor") &&
      (event.target as HTMLElement).tagName.toLowerCase() !== "textarea"
    ) {
      event.preventDefault();
      if (this.taskIdSelected === undefined || this.taskIdSelected === 0) {
        this.addTask();
      } else if (
        this.taskIdSelected !== undefined &&
        this.taskIdSelected !== 0
      ) {
        this.updateTask();
      }
    }
  }

  popolateBuyerNameAfterContactAdded(buyerName: string) {
    this.selectedBuyer = buyerName;
    this.form.patchValue({
      subTask: {
        buyerName: buyerName,
      },
    });

    this.loadBuyersLazy(null, true);
  }

  refreshBuyerGridList() {
    this.buyerLists = [];
    this.buyerCurrentSearchTerm = "";
    this.loadBuyersLazy({ first: 0, rows: 50 }, true);
  }

  getTaskProjectOrderLinesDetails(
    projectWorkFlowId: number,
    lineRecId: number
  ) {
    if (projectWorkFlowId > 0 && lineRecId > 0) {
      this.showSmallLoader = true;
      this._taskManagementService
        .getTaskProjectOrderLinesDetails(projectWorkFlowId, lineRecId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res?.status?.toLowerCase() !== "success") {
              this._toastr.error(
                "Error",
                res.message ?? "Unable to get line details"
              );
              this.setDynamicValidation("Production Task");
              return;
            } else {
              this.getTaskProjectOrderLinesDetailsDto = res.data;
              if (
                this.getTaskProjectOrderLinesDetailsDto.isSetupLine === true
              ) {
                this._toastr.error(
                  "Error",
                  `Linked order line#${this.getTaskProjectOrderLinesDetailsDto.lineNumberD365} is a setup line at associated Order#${this.taskDetail.salesOrderId}`
                );
                this.setDynamicValidation("Production Task");
                return;
              } else if (
                this.getTaskProjectOrderLinesDetailsDto.isTrackable === false
              ) {
                this._toastr.error(
                  "Error",
                  `Linked order line#${this.getTaskProjectOrderLinesDetailsDto.lineNumberD365} is not trackable at associated Order#${this.taskDetail.salesOrderId}`
                );
                this.setDynamicValidation("Production Task");
                return;
              } else {
                this.form.patchValue({
                  subTask: {
                    purchaseOrderNumber:
                      this.getTaskProjectOrderLinesDetailsDto.poNumber,
                    supplier: this.getTaskProjectOrderLinesDetailsDto.supplier,
                    ihd: this.getTaskProjectOrderLinesDetailsDto?.inHandDate
                      ? new Date(
                          this.getTaskProjectOrderLinesDetailsDto.inHandDate
                        )
                      : "",
                    esd: this.getTaskProjectOrderLinesDetailsDto?.esd
                      ? new Date(this.getTaskProjectOrderLinesDetailsDto.esd)
                      : "",
                  },
                });
              }
            }
          },
        });
    }
  }

  redirectToWorkflowSummary() {
    const project = this.form.get("subTask.project")?.value;
    const salesOrderId = this.form.get("subTask.linkedOrder")?.value || "0";
    const showCloseIcon = false;
    if (project) {
      const url = this._router.serializeUrl(
        this._router.createUrlTree([
          `/project-workflow/workflow-summary/${project}/${salesOrderId}/${showCloseIcon}`,
        ])
      );
      window.open(url, "_blank");
    }
  }

  get projectControl() {
    return this.form.get("subTask.project");
  }
}
